import { loadState, saveState } from 'utils/storage';
import { ScenarioPlan } from 'views/playground/features/bluviu-nutrition-r2/types/scenario-plan.type';
import { UpdateStepOneInput } from 'views/playground/features/bluviu-nutrition-r2/types/update-step-one-input.type';

export const putStepOne = async (data: UpdateStepOneInput): Promise<ScenarioPlan> => {
  const raw = loadState({ key: 'getPlaygroundScenarioPlan', storage: 'session' });

  const parsed = (typeof raw === 'string' ? JSON.parse(raw) : raw) as ScenarioPlan; // try to parse safely

  const updatedScenarioPlan: ScenarioPlan = { ...parsed, stepOneFields: { ...data } }; // combine data and save in session for test

  saveState({ key: 'getPlaygroundScenarioPlan', storage: 'session', state: updatedScenarioPlan }); // save in session for persistent display

  return updatedScenarioPlan; // return combined data
};
